// Static published survey figures, transcribed without recalculation from "SIA KPIs.html".
// Order: NOGA 711101, 711102, 711103, 711201, 711202, 711203, 711204, 711205, all sectors.
export const overviewRows = [
  { noga: "711101", survey2014: "52.2%", survey2025: "65.42%", difference: "+13.22%" },
  { noga: "711102", survey2014: "44.9%", survey2025: "69.71%", difference: "+24.81%" },
  { noga: "711103", survey2014: "50.2%", survey2025: "52.76%", difference: "+2.56%" },
  { noga: "711201", survey2014: "50.7%", survey2025: "48.75%", difference: "-1.95%" },
  { noga: "711202", survey2014: "53.7%", survey2025: "55.42%", difference: "+1.72%" },
  { noga: "711203", survey2014: "52.4%", survey2025: "45.67%", difference: "-6.73%" },
  { noga: "711204", survey2014: "58.9%", survey2025: "56.67%", difference: "-2.23%" },
  { noga: "711205", survey2014: "-", survey2025: "51.88%", difference: "-" },
  { noga: null, survey2014: "52.4%", survey2025: "59.98%", difference: "+7.58%" },
];

export const costRows = [
  { key: "cost-1", values: ["2.15%", "3.42%", "1.77%", "2.25%", "2.67%", "1.54%", "2.08%", "3.81%", "2.29%"] },
  { key: "cost-2", values: ["29.78%", "29.26%", "26.61%", "19.89%", "22.30%", "20.00%", "19.62%", "19.38%", "26.15%"] },
  { key: "cost-3", values: ["11.39%", "8.99%", "7.27%", "6.61%", "6.12%", "6.33%", "7.01%", "7.81%", "9.41%"] },
  { key: "cost-4", values: ["0.98%", "0.93%", "1.04%", "0.50%", "0.54%", "0.38%", "1.96%", "0.50%", "0.93%"] },
  { key: "cost-5", values: ["1.43%", "2.11%", "0.99%", "1.54%", "0.38%", "1.15%", "1.63%", "1.31%", "1.48%"] },
  { key: "cost-6", values: ["2.54%", "2.90%", "1.42%", "2.52%", "2.36%", "1.65%", "1.45%", "1.44%", "2.36%"] },
  { key: "cost-7", values: ["4.45%", "4.30%", "4.41%", "3.21%", "4.73%", "3.98%", "3.44%", "3.90%", "4.09%"] },
  { key: "cost-8", values: ["5.58%", "7.43%", "3.74%", "6.27%", "8.11%", "5.58%", "7.46%", "6.98%", "6.03%"] },
  { key: "cost-9", values: ["0.46%", "0.85%", "0.39%", "0.41%", "0.98%", "0.17%", "0.38%", "0.51%", "0.47%"] },
  { key: "cost-10", values: ["2.30%", "2.37%", "0.90%", "1.56%", "0.73%", "0.74%", "1.45%", "0.94%", "1.92%"] },
  { key: "cost-11", values: ["1.22%", "1.20%", "2.14%", "0.66%", "0.17%", "1.31%", "2.23%", "1.64%", "1.24%"] },
  { key: "cost-12", values: ["2.94%", "5.50%", "1.97%", "2.89%", "6.03%", "2.81%", "6.83%", "3.28%", "3.27%"] },
  { key: "cost-13", values: ["0.20%", "0.47%", "0.10%", "0.43%", "0.28%", "0.55%", "1.14%", "0.37%", "0.32%"] },
];

// The detailed table's total row matches the published 2025 overview,
export const totalCosts = overviewRows.map(({ survey2025 }) => survey2025);
